import { trackFirebase } from '@otto-ec/apps-api/thirdpartytracking';

export class FireBaseBridge {
    constructor() {}

    emitEvent(eventName: string, itemId: string, itemName: string, productBaseClass: string, quantity: number): void {
        trackFirebase({
            event_name: eventName,
            event_params: {
                items: [{ item_id: itemId, item_name: itemName, item_category: productBaseClass, quantity }]
            }
        });
    }

    emitAddToBasketEvent(event: AddToBasketEvent): void {
        try {
            this.emitEvent('add_to_cart', event.articleNumber, event.itemName, event.itemCategory, event.addedQuantity);
        } catch (e) {
            if (window.o_global.debug.status().activated) {
                console.error(e);
            }
        }
    }

    static initialize(): void {
        const o_order = window.o_order ?? {};

        o_order.firebaseBridge = o_order.firebaseBridge ?? new FireBaseBridge();
    }
}

export interface AddToBasketEvent {
    articleNumber: string;
    itemName: string;
    itemCategory: string;
    addedQuantity: number;
}
